import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 16px;
  height: 16px;
`
const CalendarTime = ({ title = 'Calendar with Time', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 48 48" title={title} {...rest}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 4.5C14.3284 4.5 15 5.17157 15 6V9H33V6C33 5.17157 33.6716 4.5 34.5 4.5C35.3284 4.5 36 5.17157 36 6V9H37.5C40.8137 9 43.5 11.6863 43.5 15V37.5C43.5 40.8137 40.8137 43.5 37.5 43.5H10.5C7.18629 43.5 4.5 40.8137 4.5 37.5V15C4.5 11.6863 7.18629 9 10.5 9H12V6C12 5.17157 12.6716 4.5 13.5 4.5ZM10.5 12C8.84315 12 7.5 13.3431 7.5 15V17.3027C8.38252 16.7922 9.40714 16.5 10.5 16.5H37.5C38.5929 16.5 39.6175 16.7922 40.5 17.3027V15C40.5 13.3431 39.1569 12 37.5 12H10.5ZM40.5 22.5C40.5 20.8431 39.1569 19.5 37.5 19.5H10.5C8.84315 19.5 7.5 20.8431 7.5 22.5V37.5C7.5 39.1569 8.84315 40.5 10.5 40.5H37.5C39.1569 40.5 40.5 39.1569 40.5 37.5V22.5Z"
      fill="#002AB4"
    />
  </StyledIcon>
)

CalendarTime.displayName = 'CalendarTime'

export default CalendarTime
